module.exports = __webpack_public_path__ + "static/24-16f668b3ea4ca71878efcefcc15904a0.png";